<template>
  <div class="min-h-screen bg-gradient-to-br from-primary-600 to-primary-900 flex items-center justify-center p-4">
    <div class="w-full max-w-xl">
      <div class="bg-white rounded-2xl shadow-2xl p-6 md:p-8">
        <div class="mb-6">
          <h1 class="text-3xl font-bold text-gray-900">{{ t('app.welcome') }}</h1>
          <p class="mt-2 text-sm text-gray-500">{{ t('app.loginPrompt') }}</p>
        </div>

        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped>
:deep(.p-input) {
  width: 100%;
}
</style>
